import React, { useState } from "react";
import "./DeleteAccount.css";

const SupportRequest = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    type: "",
    details: ""
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // TODO: Connect to backend or email service
    console.log("Support request submitted:", form);

    setSubmitted(true);
    setForm({
      name: "",
      email: "",
      type: "",
      details: ""
    });
  };

  return (
    <section className="delete-account">
      <div className="delete-container">

        {/* OFFICIAL HEADER */}
        <h1>IPKOBRAIL – Account Deletion & Child Safety Request</h1>

        <div className="official-info">
          <p><strong>Developer / Company:</strong> IPKOBRAIL</p>
          <p>
            This is the official account deletion and child safety request
            page managed and maintained by IPKOBRAIL for applications
            published on Google Play.
          </p>
        </div>

        <p>
          Users may request permanent account deletion or report child safety
          concerns using the form below. All requests are reviewed within
          <strong> 2 working days</strong>. Urgent safety matters are prioritized.
        </p>

        <p>
          Alternatively, you may request deletion by emailing:
          <strong> support@ipkobrail.com </strong>
          with subject line:
          <strong> "Account Deletion Request"</strong>.
        </p>

        <form onSubmit={handleSubmit}>

          <div className="form-group">
            <label>Request Type</label>
            <select
              name="type"
              value={form.type}
              onChange={handleChange}
              required
            >
              <option value="">Select request type</option>
              <option value="account_deletion">Account Deletion</option>
              <option value="child_safety">Child Safety Concern</option>
            </select>
          </div>

          <div className="form-group">
            <label>Full Name</label>
            <input
              type="text"
              name="name"
              placeholder="Enter your full name"
              value={form.name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Registered Email Address</label>
            <input
              type="email"
              name="email"
              placeholder="Enter your registered email"
              value={form.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Details of Your Request</label>
            <textarea
              name="details"
              rows="4"
              placeholder="Provide complete details regarding your request."
              value={form.details}
              onChange={handleChange}
              required
            ></textarea>
          </div>

          <button type="submit" className="btn-submit">
            Submit Request
          </button>
        </form>

        {submitted && (
          <div className="popup">
            <div className="popup-box">
              <h3>Request Received Successfully</h3>
              <p>
                Your request has been received by IPKOBRAIL support team.
                We will review it within <strong>2 working days</strong>.
              </p>
              <button onClick={() => setSubmitted(false)}>Close</button>
            </div>
          </div>
        )}

        <div className="policy-section">
          <h2>Policy Information</h2>

          <h3>Account Deletion Policy</h3>
          <p>
            Upon verification, user accounts and associated personal data
            will be permanently removed from our systems.
            Certain information may be retained temporarily where required for:
          </p>

          <ul>
            <li>Legal compliance</li>
            <li>Fraud prevention</li>
            <li>Security investigations</li>
            <li>Financial record keeping</li>
          </ul>

          <h3>Child Safety Policy</h3>
          <p>
            IPKOBRAIL maintains zero tolerance for child exploitation,
            abuse, or harmful content involving minors.
            All reported concerns are reviewed immediately and may be reported
            to appropriate authorities when required.
          </p>
        </div>

      </div>
    </section>
  );
};

export default SupportRequest;